import React, { useState } from 'react';
import axios from 'axios';
import { MessageCircle, Mail, Phone, Send, ArrowRight } from 'lucide-react';
import { contactData } from '../../data/mock';
import '../../styles/landing.css';

const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000').replace(/\/$/, '');

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleChange = (e) => {
    setFormData((currentData) => ({ ...currentData, [e.target.name]: e.target.value }));
    setSubmitError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    try {
      await axios.post(`${API_BASE_URL}/api/contact`, formData);
      setIsSubmitting(false);
      setSubmitted(true);
      setFormData({ name: '', email: '', phone: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (error) {
      const apiMessage = error.response?.data?.detail;
      setSubmitError(apiMessage || 'No se pudo enviar el mensaje. Revisa tu conexion e intenta nuevamente.');
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="section section-dark">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <div className="section-label" style={{ textAlign: 'left', paddingLeft: 0 }}>
              Contacto
            </div>
            <h2 className="heading-1" style={{ color: 'white' }}>{contactData.title}</h2>
            <p className="body-large">{contactData.description}</p>

            <div className="space-y-2">
              <a
                href={`https://wa.me/${contactData.whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-item"
              >
                <div className="contact-item-icon">
                  <MessageCircle size={22} />
                </div>
                <div className="contact-item-text">
                  <h4>WhatsApp</h4>
                  <p>{contactData.whatsapp}</p>
                </div>
                <ArrowRight size={18} className="ml-auto text-[#D4AF37]" />
              </a>

              <a href={`mailto:${contactData.email}`} className="contact-item">
                <div className="contact-item-icon">
                  <Mail size={22} />
                </div>
                <div className="contact-item-text">
                  <h4>Correo Electronico</h4>
                  <p>{contactData.email}</p>
                </div>
                <ArrowRight size={18} className="ml-auto text-[#D4AF37]" />
              </a>

              <a href={`tel:+${contactData.whatsappNumber}`} className="contact-item">
                <div className="contact-item-icon">
                  <Phone size={22} />
                </div>
                <div className="contact-item-text">
                  <h4>Telefono</h4>
                  <p>{contactData.whatsapp}</p>
                </div>
                <ArrowRight size={18} className="ml-auto text-[#D4AF37]" />
              </a>
            </div>
          </div>

          <div className="contact-form-wrapper">
            {submitted ? (
              <div className="text-center py-12">
                <div className="w-20 h-20 bg-[#0a1628] flex items-center justify-center mx-auto mb-6">
                  <Send size={32} className="text-[#D4AF37]" />
                </div>
                <h3 className="heading-2 mb-2">Mensaje enviado</h3>
                <p className="body-medium text-gray-600">
                  Me pondre en contacto contigo pronto.
                </p>
              </div>
            ) : (
              <>
                <h3 className="heading-2">Solicita tu Consulta Gratuita</h3>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-label" htmlFor="contact-name">Nombre Completo *</label>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="form-input"
                      placeholder="Ingresa tu nombre"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label" htmlFor="contact-email">Correo Electronico *</label>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="form-input"
                      placeholder="tu@correo.com"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label" htmlFor="contact-phone">Telefono (Opcional)</label>
                    <input
                      id="contact-phone"
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="+51 999 999 999"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label" htmlFor="contact-message">Mensaje *</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows={4}
                      className="form-input"
                      style={{ resize: 'none' }}
                      placeholder="Cuentame sobre tu negocio y como puedo ayudarte..."
                    />
                  </div>

                  {submitError && (
                    <p className="form-error" role="alert">{submitError}</p>
                  )}

                  <button type="submit" className="btn-dark w-full" disabled={isSubmitting}>
                    {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                    <Send size={18} />
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
